// components/MyTable.js
import React from 'react';
import { Table } from 'antd';
import { useNavigate } from 'react-router-dom';

const MyTable = ({ columns, dataSource, pagination = true, footer }) => {
    const navigate = useNavigate();
  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      pagination={pagination}
      rowKey={(record) => record.id || record.key}
      tableLayout="auto"
    />
  );
};

export default MyTable;
